<template>
    <ul class="fission-cardList uls">
      <template v-if="cardList && cardList.length">
        <List v-model="loading"
              :finished="finished"
              :finished-text="$tools.finishedText(error, cardList)"
              :immediate-check="false"
              :error.sync="error"
              error-text="请求失败，点击重新加载!"
              @load="onLoad">
          <li v-for="(item, index) in cardList" :key="index" @click="$emit('onClick', item)">
            <p class="actTitle">
              <span>
                <span><img :src="flagImg" alt=""></span>
                活动：{{item.actTitle}}
              </span>
              <span class="status" :class="{'done': ['-1', '5'].includes(item.orderItemStatus)}">{{item.orderItemStatus | getStatusName(item)}}</span>
            </p>
            <template>
                <div class="info">
                  <div class="img">
                    <img
                      v-if="item.img"
                      v-lazy="`${imgAddr}${item.img}${$conf.lovehome.oss2}`"
                      :src="`${imgAddr}${item.img}${$conf.lovehome.oss2}`"
                      alt="图片加载失败">
                    <img
                      v-else
                      :src="defaultSellCardImg"
                      alt="图片加载失败">
                  </div>
                  <div class="info-right">
                    <p class="title">{{item.title}}</p>
                    <p class="brand" v-if="item.orderNo" @click.stop="onCopy(item.orderNo)">订单编号：<span ref="copyURL">{{item.orderNo}}</span><img :src="copyImg" class="copyImg"/></p>
                    <p class="brand" v-if="cardType===3">{{item.usageMode}}</p>
                    <p class="brand">导购：{{item.belongUserName}} <span class="phone" @click.stop="clickGuidePhone(item.belongUserMobile)">{{item.belongUserMobile}}</span></p>
                    <p class="brand">{{item.orgName}}</p>
                    <p class="brand">品牌品类：{{item.brandName}}-{{item.categoryName}}</p>
                    <p class="brand">价格：{{item.totalMoney}}</p>
                  </div>
                </div>
                <div class="creatTime">
                  <Row>
                    <Col :span="item.btnList && item.btnList.length ? 14 : 24" v-if="item.showDateTime">
                      <span>{{item.showDateTime || ''}}</span>
                    </Col>
                    <Col :span="item.showDateTime ? 10 : 24" class="btnRight" v-if="item.btnList && item.btnList.length">
                      <button  class="fission-writeOff writeOff" @click.stop="writeOff(item,btn)" v-for="(btn,index) in item.btnList">{{btn}}</button>
                    </Col>
                  </Row>
                </div>
              </template>
          </li>
        </List>
      </template>
      <div class="noData" v-else-if="!refreshing">
        <no-data height="0" :img="errImgList[0]" :text="infoText" class="bg-white" />
      </div>
    </ul>
</template>

<script>
import NoData from '../../components/base/NoData';
import { Col, Row, List, Dialog } from 'vant';

export default {
  name: 'cardList',
  components: { List, NoData ,Col, Row },
  computed: {
    copyImg() {
      return  this.$fission.setImgAddress("config/", 'copy.png');
    },
    flagImg() {
      return this.$fission.setImgAddress('user/mine/', 'flag.png');
    },
  },
  data() {
    return {
      imgAddr: systemConfig.imageServer,
      errImgList: [this.$user.heziImg, this.$user.shopImg],
      defaultSellCardImg: 'default.png',
    };
  },
  props: {
    cardList: {
      type: Array,
      default() {
        return [];
      },
    },
    cardType: { // 0 我的秒杀 1我的下订 2我的优惠券
      type: Number,
      default: 0,
    },
    infoText: {
      type: String,
      default: '暂时还没有数据哦~~',
    },
    loading: {
      type: Boolean,
      default: false
    },
    refreshing: {
      type: Boolean,
      default: false
    },
    finished: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
  },
  filters: {
    getStatusName(status, item) {
      if (status === '1' && item.orderItemId) {
        return '待付款';
      }
      if (status === '-1' && item.orderItemId) {
        return '已失效';
      }
      // 需要发货
      if(item.delivery) {
        if (status === "3") {
          return '待发货';
        } else if(status === "5") {
          return '已发货';
        }
      }
      else{  // 不需要发货
        if(status === "3") {
          return '待核销';
        }else if(status === "5"){
          return '已核销';
        }
      }
      return '';
    }
  },
  methods: {
    writeOff(item,btn) {
      this.$emit('writeOff', item, this.cardType, btn);
    },
    onLoad() {
      this.$emit('getData');
    },
    onCopy(orderNo) {
      // 选中节点url内容
      const textarea= document.createElement('textarea');
      textarea.setAttribute('readonly', 'readonly');
      textarea.value = orderNo;
      document.body.appendChild(textarea);
      textarea.select();
      const isSuccess = document.execCommand('copy');
      document.body.removeChild(textarea);
      if (isSuccess) {
        this.$tools.successToast('复制成功');
      }
    },
    clickGuidePhone(phone) {
      this.$request.userBasic.behaviorTrace();
      this.$tools.playPhone(phone);
    },
  },
  created() {
    this.defaultSellCardImg = this.$fission.setImgAddress('user/mine/sellcard/', this.defaultSellCardImg);
  }
};
</script>

<style lang="less" scoped>
  .uls{
    /*padding:15px 0;*/
    overflow:hidden;
    li{
      background:#fff;
      padding:18px 11px;
      overflow:hidden;
      border-radius: 8px;
      margin-bottom: 12px;
      &:last-child{
        border:none;
      }
    }
  }
  .actTitle{
    font-size:14px;
    color:#333;
    font-weight:bold;
    display:flex;
    justify-content:space-between;
    margin: 0 0 8px 0;
    span{
      flex:8;
      span{
        display:inline-block;
        width:20px;
        height:20px;
        border-radius:50%;
        text-align:center;
        line-height:20px;
        background:#FFE6E1;
        img{
          width:10px;
          height:10px;
        }
      }
    }
    span.status{
      color:#F58E18;
      min-width:60px;
      text-align:right;
      flex: 4;
      font-weight:normal;
    }
    span.done{
      color:#999999 !important;
    }
  }
  .info{
    display:flex;
    position:relative;
    overflow:hidden;
    .img{
      width:100px;
      flex:0 0 auto;
      border-radius:6px;
      overflow:hidden;
      img{
        width:100%;
        border-radius:6px;
      }
    }
    .img2{
      margin-left:5px;
    }
    .info-right{
      flex:1 1 auto;
      margin-left:10px;
      position:relative;
      overflow:hidden;
      p{
        margin:5px 0 0;
        &:first-child{
          margin:0;
        }
      }
      .title{
        color:#333;
        font-size:17px;
        font-weight:bold;
      }
      .brand{
        color:#888;
        font-size:12px;
      }
      .money{
        text-align: right;
        font-size:15px;
        color:#E02600;
      }
    }
    .coupon-left{
      margin-left:0;
    }
  }
  .couponList{
    border-width:3px 1px 1px;
    border-style:solid;
    border-color:#F5A623;
    padding:5px 10px 15px;
    .statusBottom{
      height: 20px;
    }
    .common_p{
      color:#888;
      font-size:11px;
      margin:0;
    }
  }
  .couponPeople{
    margin-top:15px;
    display:flex;
    justify-content:space-between;
    font-size:14px;
    color:#333;
  }
  .actBorder{
    border-color:#DFDFDF;
  }
  .name{
    color:#666;
    font-size:14px;
    margin-top:10px;
    overflow:hidden;
    .left{
      text-align:left;
    }
    .right{
      text-align:right;
    }
  }
  .creatTime{
    color:#666;
    font-size:12px;
    overflow:hidden;
    .btnRight{
      margin-top: 5px;
      display: flex;
      text-align: right;
      justify-content: flex-end;
      button{
        margin: 0 5px;
      }
    }
    .writeOffName{
      font-size:14px;
      color:#333;
    }
  }
  .couponInfo{
    margin-top:15px;
    p{
      color:#888;
      font-size:11px;
      span{
        float:right;
      }
    }
  }
  .writeOff{
    float:right;
    border:1px solid #E02600;
    color:#E02600;
    font-size:14px;
    padding:5px 15px;
    background:#fff;
    border-radius:18px;
    outline:none;
  }
  .couponWriteOff{
    margin:15px 0 0;
  }
  .assist{
    background: orange;
    color:#fff;
    display:inline-block;
    float:right;
    padding:5px;
    border-radius:5px;
  }
  .loadMore{
    padding: 0.5em 0;
    text-align: center;
    width: 100%;
    a {
      color: #3a3a3a;
      font-size: 14px;
      text-decoration: none;
    }
    >p{
      text-align: center;
      padding:1em 0;
    }
  }
  .noData{
    width: 100%;
    background: #fff;
  }
  .bg-white{
    background: #fff;
  }
  .collect-like-progress{
    margin-top: 10px;
    display: flex;
    align-items: center;
    .progress-text{
      font-size: 14px;
      color: #333333;
      span{
        color: #E02600;
        margin-left: 5px;
      }
    }
    .progress-line{
      flex: 1;
      height: 12px;
      background-color: #F7E8E8;
      border-radius: 7px;
      margin-right: 12px;
      >div{
        background-color: #F06043;
        border-top-left-radius: 7px;
        border-bottom-left-radius: 7px;
        height: 12px;
      }
      .done{
        border-top-right-radius: 7px;
        border-bottom-right-radius: 7px;
      }
    }
  }
  .copyImg{
    width: 12px;
    margin-left: 5px;
  }
  .phone{
    color: #4A90E2;
    margin-left: 2px;
  }
</style>
